module.exports = __webpack_public_path__ + "static/media/dwellPass-emblem-map-blue-shadow-120.1bde3bbd.png";